// imports
import { pxToRem } from '@withjoy/joykit/theme';
import { Flex, styled } from '@withjoy/joykit';

// local imports
import { rgba } from '@shared/utils/style/rgba';

export const TopBarContainer = styled(Flex)`
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  align-items: center;
  height: ${pxToRem(64)};
  padding: 0 ${pxToRem(80)};
  backdrop-filter: blur(8px);
  justify-content: space-between;
  z-index: ${({ theme }) => theme.zIndices.overlay};
  background-color: ${({ theme }) => rgba(theme.colors.fillLight, 0.95)};
  border-bottom: ${({ theme }) => `1px solid ${rgba(theme.colors.mono14, 0.08)}`};
`;

export const LogoContainer = styled(Flex)`
  cursor: pointer;
  align-items: center;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  svg {
    width: auto;
    max-height: ${pxToRem(38)};
  }
`;

export const CurrencySelectorContainer = styled(Flex)`
  flex-shrink: 0;
  align-items: center;
`;
